import { Query } from '@skylab-shared/core';
import { Exclude, Type } from 'class-transformer';

export interface PagedCollectionQueryResult<TCollectionItem> {
    readonly items: TCollectionItem[];
    readonly totalItemsCount: number;
}

export class PagedCollectionQueryResultDTO<T> {
    @Exclude()
    private type: Function;

    @Type(options => (options?.newObject as PagedCollectionQueryResultDTO<T>).type)
    public items: T[];

    public totalItemsCount: number;

    public constructor(type: Function) {
      this.type = type;
    }
}

export interface PagedCollectionQueryParams {
    readonly pageNo?: number;
    readonly pageSize?: number;
    readonly search?: string;
    readonly orderBy?: string[];
    readonly [param: string]: any;
}

export enum OrderDirection {
    Asc = 'Asc',
    Desc = 'Desc'
}

export class PagedCollectionQuery<TCollectionItem> extends Query<PagedCollectionQueryResult<TCollectionItem>> {
    public constructor(public readonly params: PagedCollectionQueryParams) {
        super();
    }
}
